// auth-service accepts `otpType` + `identifier` and returns camelCase wrapped in
// a gateway `data` envelope. The only payload we actually read back is the
// VerifyOtp response (requestToken).

export const OTP_TYPE_RESET_PASSWORD = 'reset_password';

export interface ISendOtpApiPayload {
  otpType: typeof OTP_TYPE_RESET_PASSWORD;
  identifier: string;
}

export type TSendOtpApiResponse = Record<string, unknown>;

export interface IVerifyOtpApiPayload {
  otpType: typeof OTP_TYPE_RESET_PASSWORD;
  identifier: string;
  otpCode: string;
}

export interface IVerifyOtpApiResponse {
  requestToken: string;
}

export interface IVerifyOtpApiEnvelope {
  data: IVerifyOtpApiResponse;
}

export interface IResetPasswordApiPayload {
  identifier: string;
  requestToken: string;
  newPassword: string;
}

export type TResetPasswordApiResponse = Record<string, unknown>;
